import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'
import _imports_1 from '@/assets/ar.svg'
import _imports_2 from '@/assets/us.svg'


const _hoisted_1 = { class: "flex flex-col items-center mt-2 md:mt-12 w-full" }
const _hoisted_2 = { class: "flex flex-col md:flex-row gap-2 md:gap-4 mt-5 w-full px-4 text-center md:w-auto" }
const _hoisted_3 = { class: "flex items-center gap-4 my-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      class: "flex flex-col items-center justify-center bg-cover bg-center md:bg-left-top bg-no-repeat",
      style: _normalizeStyle({ backgroundImage: 'url(' + require(`@/assets/header.jpg`) + ')' })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[8] || (_cache[8] = _createElementVNode("img", {
          class: "object-contain w-11/12 md:w-8/12 lg:w-4/12",
          src: _imports_0
        }, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "px-5 py-2 border border-[#f19d3b] bg-[#f19d3b] text-white font-semibold hover:bg-white hover:text-[#f19d3b] rounded-md"
          }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "pi pi-user mr-2" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('boton.soy.invitado')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/colegios",
            class: "px-5 py-2 border border-[#f19d3b] bg-[#f19d3b] text-white font-semibold hover:bg-white hover:text-[#f19d3b] rounded-md"
          }, {
            default: _withCtx(() => [
              _cache[3] || (_cache[3] = _createElementVNode("i", { class: "pi pi-globe mr-2" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('boton.soy.colegio')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/prensa",
            class: "px-5 py-2 border border-[#f19d3b] bg-[#f19d3b] text-white font-semibold hover:bg-white hover:text-[#f19d3b] rounded-md"
          }, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("i", { class: "pi pi-credit-card mr-2" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('boton.soy.prensa')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/credenciales",
            class: "px-5 py-2 border border-[#f19d3b] bg-[#f19d3b] text-white font-semibold hover:bg-white hover:text-[#f19d3b] rounded-md"
          }, {
            default: _withCtx(() => [
              _cache[5] || (_cache[5] = _createElementVNode("i", { class: "pi pi-qrcode mr-2" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('boton.ya.acreditado')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLanguage('es'))),
            class: "hover:opacity-70 transition"
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("img", {
              src: _imports_1,
              class: "h-8"
            }, null, -1)
          ]))]),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage('en'))),
            class: "hover:opacity-70 transition"
          }, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("img", {
              src: _imports_2,
              class: "h-8"
            }, null, -1)
          ]))])
        ])
      ])
    ], 4),
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "w-full h-1 bg-[#00007b]" }, null, -1))
  ], 64))
}